import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[580px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Clean%20white%20minimalist%20dairy%20product%20background%20with%20soft%20cream%20and%20beige%20tones%2C%20abstract%20organic%20flowing%20shapes%20like%20milk%20splashes%2C%20elegant%20smooth%20textures%2C%20warm%20natural%20lighting%2C%20serene%20and%20sophisticated%20atmosphere%2C%20no%20text%2C%20no%20people%2C%20high-end%20editorial%20style&width=1920&height=1080&seq=hero-bg-milk&orientation=landscape"
          alt="牛奶片库"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-5 leading-tight" style={{ fontFamily: "var(--font-heading)" }}>
          精选牛奶片大全
          <br />
          <span className="text-primary-400">品质甄选一站购齐</span>
        </h1>
        <p className="text-base md:text-lg text-background-50/85 mb-8 max-w-2xl mx-auto leading-relaxed">
          牛奶片库汇聚海量优质牛奶片产品，涵盖儿童牛奶片、成人牛奶片、进口牛奶片等多种品类。严选品牌，为您提供详尽的成分对比、口感测评与购买指南。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-10">
          <Link
            to="/category/children"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-medium rounded-full text-sm whitespace-nowrap hover:bg-primary-600 transition-colors no-underline hover:no-underline"
          >
            <i className="ri-store-2-line mr-2"></i>浏览全部产品
          </Link>
          <Link
            to="/article/milk-tablet-buying-guide-complete"
            className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 font-medium rounded-full text-sm whitespace-nowrap border border-background-50/30 hover:bg-background-50/25 transition-colors no-underline hover:no-underline"
          >
            <i className="ri-book-open-line mr-2"></i>查看选购指南
          </Link>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50">10,000+</p>
            <p className="text-xs text-background-50/70 mt-1">真实用户测评</p>
          </div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50">50+</p>
            <p className="text-xs text-background-50/70 mt-1">精选品牌</p>
          </div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50">200+</p>
            <p className="text-xs text-background-50/70 mt-1">专业评测文章</p>
          </div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50">6</p>
            <p className="text-xs text-background-50/70 mt-1">精细分类</p>
          </div>
        </div>
      </div>
    </section>
  );
}